<header class="header">
    <div class="container-fluid">
        <div class="row">
            <div class="header__mobile  visible-xs">
                <button class="fa fa-bars" v-on:click="mobileNav = !mobileNav" :class="{ 'fa-arrow-left': mobileNav }"></button>
            </div>
            <div class="header__logo col-xs-12 col-sm-4 col-md-3">
                <router-link :to="{ name: 'Performers' }"><img alt="logo" :src="logo"></router-link>
            </div>
            <div class="header__intro hidden-xs hidden-sm col-md-3">
                <span>{{ content.settings.slogan }}</span>
            </div>
            <div class="header__search hidden-xs col-sm-4 col-md-3">
                <form class="search" v-on:submit.prevent="search">
                    <input type="text" name="search" v-model="searchQuery" :placeholder="$t('header.search')">
                    <button class="button"><span class="fa fa-search"></span></button>
                </form>
            </div>
            <div class="header__phone col-xs-12 col-sm-4 col-md-3">
                <div class="header__phone-number">{{ content.settings.phone }}
                    <span>{{ content.settings.phonecost | currency }} {{ $t('header.cost') }}</span>
                </div>
            </div>
            <div class="header__nav" v-if="mobileNav">
                <router-link :to="{ name: 'Performers' }" class="header__nav-item fa fa-home hidden-xs"></router-link>
                <span class="header__nav-item visible-xs">
                    <form class="search">
                        <input type="text" name="search" placeholder="Zoeken...">
                        <button class="button"><span class="fa fa-search"></span></button>
                    </form>
                </span>
                <router-link class="header__nav-item" v-for="category in categories" :key="category.slug" :to="{ name: 'PerformersCat', params: { category: category.slug } }">{{ category.title }}</router-link>
            </div>
        </div>
    </div>
</header>


// WEBPACK FOOTER //
// ./src/components/layout/header.tpl.html